export enum BonusRuleStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
